export enum Actions {
  // User Details
  requestLoginWithEmail = "requestLoginWithEmail",
  requestAdminlogout = "requestAdminlogout",
  requestInitializeUser = "requestInitializeUser",
  requestReferrals = "requestReferrals",
  requestReferredUsers = "requestReferredUsers",
  requestUpdateReferrals = "requestUpdateReferrals",
  requestPasswordReset = "requestPasswordReset",
  requestReferralIncentiveDetails = "requestReferralIncentiveDetails",
}
